export default __webpack_public_path__ + "static/media/dinersclub.c46b1ef3.png";